import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";


import styles from "./styles.module.scss";
import i18n from "i18n";

export class AddConfigTagStepThree extends React.Component {
  render() {
    const { configTag, options, handleSelect, goBack, handleFinish, error } = this.props;

    const stepContent = (
      <form onSubmit={handleFinish}>
      <div className={styles["add-config-tag-wizard-step-three-content"]}>
        <div className={styles["add-config-tag-wizard-step-three-field"]} data-automation-id="input-mem_epc">
          <MainDropdownInput
            required={true}
            id={"configTag-mem-epc"}
            name="mem-epc"
            selectedOption={configTag ? configTag.mem_epc : ''}
            handleSelection={(selectedOption) => handleSelect(selectedOption, 'mem_epc')}
            maxLength={50}
            options={options.mem_epc}
            placeholder={i18n.t("epc.memory")}
            label={i18n.t("epc.memory")}
            error={error.mem_epc && error.mem_epc}
          />
        </div>
        <div className={styles["add-config-tag-wizard-step-three-field"]} data-automation-id="input-mem_user">
          <MainDropdownInput
            required={true}
            id={"configTag-mem-user"}
            name="mem-user"
            selectedOption={configTag ? configTag.mem_user : ''}
            handleSelection={(selectedOption) => handleSelect(selectedOption, 'mem_user')}
            maxLength={50}
            options={options.mem_user}
            placeholder={i18n.t("user.memory")}
            label={i18n.t("user.memory")}
            error={error.mem_user && error.mem_user}
          />
        </div>
        <div className={styles["add-config-tag-wizard-step-three-action-wrapper"]}>
          <button type="submit" className={styles["add-config-tag-wizard-step-three-action-button"]}>
            {i18n.t("continue").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-config-tag-wizard-step-three-container"]}>
        <Step title={i18n.t("memory")} content={stepContent} goBackFunc={goBack}></Step>
      </div>
    );
  }
}

export default AddConfigTagStepThree;
